import { generateColors } from '@mantine/colors-generator';
import { createTheme, rem } from '@mantine/core';

export const ruleEditorTheme = createTheme({
  focusRing: 'auto',
  scale: 1,
  fontSmoothing: true,
  white: '#ffffff',
  black: '#000000',
  colors: {
    customprimary: generateColors( '#53959f' ),
    tesellylight: generateColors( '#ebf2f4' ),
    tesellydark: generateColors( '#006272' ),
    secondary: generateColors( '#4a6da7' ),
    success: generateColors( '#4a9f69' ),
    warning: generateColors( '#d9963e' ),
    danger: generateColors( '#d95a5a' ),
    info: generateColors( '#4a9fb7' )
  },
  primaryColor: 'customprimary',
  fontFamily: 'Inter, sans-serif',
  spacing: {
    none: rem( 0 ),
    xxs: rem( 6 ),
    xs: rem( 10 ),
    sm: rem( 12 ),
    md: rem( 16 ),
    lg: rem( 20 ),
    xl: rem( 32 )
  },
  other: {
    modalSizes: {
      xxl: { width: '1200px', height: '85vh' },
      xxxl: { width: '1400px', height: '85vh' }
    }
  }
});
